<template>
  <div>
    <!-- <el-button class="header-custom-btn" :style="{color: scrollState ? '#00161A' : '#fff'}" v-if="isLogin" @click="$store.dispatch('showAuthModal', 'login')">用户登录</el-button> -->
    
    <div class="user-info" v-if="!user" @click="toLogin">
      <el-avatar :src="require('@/assets/images/dfavatar.png')"></el-avatar>
      <div
        class="nickname ml-10"
        :style="{ color: scrollState ? '#00161A' : '#fff' }"
      >
        立即登录
      </div>
    </div>
    <div class="user-info" v-else @click="toMyIndex">
      <div class="message-bell" @click.stop="toNotifications">
        <el-badge v-if="unreadCount > 0" :value="unreadCount" :max="99">
          <i class="el-icon-bell" :style="{ color: scrollState ? '#00161A' : '#fff' }"></i>
        </el-badge>
        <i v-else class="el-icon-bell" :style="{ color: scrollState ? '#00161A' : '#fff' }"></i>
      </div>
      <!-- <span @click="$router.push('/user/profile')"> -->
      <img :src="user.avatarUrl ? user.avatarUrl : require('@/assets/images/dfavatar.png')"></img>
      <div
        class="nickname"
        :style="{ color: scrollState ? '#00161A' : '#fff' }"
      >
        {{ user.username }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { userDetail, getUnreadMessageCount } from "@/api/lx";
export default {
  components: {},
  props: {
    // 页面滚动状态，用于控制头部文字及图标的颜色（true 为深色/常规模式，false 为透明/浅色模式）
    scrollState: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const cachedUser = localStorage.getItem("user");
    return {
      // 当前登录的用户信息（优先从本地缓存读取）
      user: cachedUser ? JSON.parse(cachedUser) : null,
      // 未读消息的数量，用于展示在小铃铛上的红点角标
      unreadCount: 0,
      // 存储 30 秒轮询定时器的引用，用于在特定时机清除
      pollingTimer: null,
    };
  },
  watch: {
    // 监听用户登录状态的变化
    user: {
      handler(val) {
        // 如果有用户信息（已登录），则开启消息未读数的轮询；如果退出登录则停止轮询
        if (val) {
          this.startPolling();
        } else {
          this.stopPolling();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["isLogin", "userInfo"]),
  },
  created() {
    // 初始化时，如果存在 token 则主动获取一次最新用户信息
    let token = localStorage.getItem("token");
    if (token) {
      this.getUser();
    }
    // 注册全局事件总线，监听消息列表组件标记已读后发出的刷新未读数的信号
    this.$root.$on('refreshUnreadCount', this.fetchUnreadCount);
    this.$root.$on('refreshUserInfo', this.getUser);
  },
  beforeDestroy() {
    // 组件销毁前，务必清理掉轮询定时器和全局事件监听，防止内存泄漏 and 重复触发
    this.stopPolling();
    this.$root.$off('refreshUnreadCount', this.fetchUnreadCount);
    this.$root.$off('refreshUserInfo', this.getUser);
  },
  methods: {
    /** 手动触发刷新用户信息 */
    refresh() {
      this.getUser();
    },
    /** 调用接口获取用户信息，并同步到 localStorage 及 vuex 中 */
    getUser() {
      userDetail({}).then((res) => {
        this.user = res.data;
        localStorage.setItem("user", JSON.stringify(res.data));
        this.$store.dispatch("userInfo", res.data);
      });
    },
    /** 跳转至登录页 */
    toLogin() {
      this.$router.push("/login");
    },
    /** 跳转至个人中心 */
    toMyIndex() {
      this.$router.push("/my/index");
    },
    /** 
     * 调用接口获取并更新总未读消息数
     * 注意：如果当前本地没有 token，会直接 return，不发起非法请求
     */
    fetchUnreadCount() {
      if (!localStorage.getItem("token")) return;
      getUnreadMessageCount()
        .then((res) => {
          if (res.code === 200) {
            this.unreadCount = res.data || 0;
          }
        })
        .catch(() => {});
    },
    /** 点击小铃铛跳转到个人中心下的消息通知模块 */
    toNotifications() {
      this.$router.push({ path: "/my/index", query: { act: "notifications" } });
    },
    /** 开启未读消息数轮询，间隔 30 秒 */
    startPolling() {
      this.fetchUnreadCount(); // 开启前先立即查一次
      if (this.pollingTimer) clearInterval(this.pollingTimer);
      this.pollingTimer = setInterval(() => {
        this.fetchUnreadCount();
      }, 30000);
    },
    /** 停止未读消息数轮询 */
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
  },
};
</script>

<style scoped lang="less">
.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  .message-bell {
    margin-right: 20px;
    font-size: 22px;
    display: flex;
    align-items: center;
  }
  img {
    margin-right: 10px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .nickname {
    font-weight: 400;
    font-size: 18px;
    color: #00161a;
    line-height: 22px;
    transition: color 0.2s ease;
  }
}
</style>